import "../index.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import buttonBackground from "../assets/button_background_blue.webp";
import ApiCall from "../auth/ApiCall";

export default function Tour() {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const navigate = useNavigate();

  const handlePrevious = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
      window.scrollTo(0, 0);
    }
  };

  const navigateAfterTour = async () => {
    try {
      const response = await ApiCall.makeAuthenticatedRequest(
        "/accounts/api/user/profile/",
      );
      const stateId = (response as { state_id?: number }).state_id;
      if (stateId !== undefined) {
        localStorage.setItem("state_id", String(stateId));
      }
      const freshStateId =
        stateId !== undefined
          ? String(stateId)
          : localStorage.getItem("state_id");
      navigate(
        freshStateId === "7" || freshStateId === "8" ? "/games" : "/subscribe",
      );
    } catch {
      // console.error("[Tour] navigateAfterTour error:", err);
      // Fall back to cached value
      const stateId = localStorage.getItem("state_id");
      navigate(stateId === "7" || stateId === "8" ? "/games" : "/subscribe");
    }
  };

  const handleNext = () => {
    if (pageNumber === 5) {
      navigateAfterTour();
      return;
    }
    setPageNumber(pageNumber + 1);
    window.scrollTo(0, 0);
  };

  const handleSkip = () => {
    navigateAfterTour();
  };

  // Responsive styles
  const isMobile = window.innerWidth <= 600;

  return (
    <div style={{ minHeight: "100vh" }}>
      <style>{`
        @media (max-width: 600px) {
          .tour-emoji {
            font-size: 40px !important;
          }
          .tour-h1 {
            font-size: 28px !important;
          }
          .tour-h2 {
            font-size: 24px !important;
          }
          .tour-h3 {
            font-size: 18px !important;
          }
          .tour-body {
            font-size: 15px !important;
          }
          .tour-small {
            font-size: 13px !important;
          }
          .tour-container {
            padding: 20px 15px !important;
          }
          .tour-card {
            padding: 20px !important;
          }
          .tour-button {
            padding: 12px 24px !important;
            font-size: 14px !important;
          }
          .tour-progress-bar {
            width: ${pageNumber >= 1 ? "40px" : "30px"} !important;
          }
        }
      `}</style>
      <div
        className="main_div_no_margin tour-container"
        style={{ paddingTop: 40, paddingBottom: 60 }}
      >
        {/* Progress Indicator */}
        <div
          className="center_me"
          style={{
            marginBottom: isMobile ? 30 : 40,
            display: "flex",
            gap: isMobile ? 6 : 10,
            justifyContent: "center",
          }}
        >
          {[1, 2, 3, 4, 5].map((num) => (
            <div
              key={num}
              className="tour-progress-bar"
              style={{
                width:
                  pageNumber >= num ? (isMobile ? 40 : 60) : isMobile ? 30 : 40,
                height: isMobile ? 6 : 8,
                backgroundColor: pageNumber >= num ? "#4CAF50" : "#333",
                borderRadius: 4,
                transition: "all 0.3s",
              }}
            />
          ))}
        </div>

        {/* Page 1: Welcome */}
        {pageNumber === 1 && (
          <>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <div
                className="tour-emoji"
                style={{ fontSize: 60, marginBottom: 20 }}
              >
                🎉
              </div>
              <h1
                className="font_family_base tour-h1 text-green"
                style={{ fontSize: 42, marginBottom: 20 }}
              >
                Welcome to StakeAlerts!
              </h1>
            </div>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <p
                className="font_family_base tour-body"
                style={{
                  fontSize: 18,
                  color: "#AAA",
                  lineHeight: 1.6,
                  marginBottom: 30,
                }}
              >
                Your all-in-one platform for tracking sports betting odds and
                receiving custom alerts when the perfect betting opportunities
                arise.
              </p>
            </div>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <div
                className="tour-card background_3 border_radius"
                style={{
                  padding: 30,
                  marginTop: 20,
                  border: "2px solid #007bff",
                }}
              >
                <h3
                  className="font_family_base tour-h3"
                  style={{ fontSize: 20, marginBottom: 20 }}
                >
                  What you'll discover:
                </h3>
                <div
                  style={{ textAlign: "left", maxWidth: 500, margin: "0 auto" }}
                >
                  <div
                    className="font_family_base tour-small"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 15,
                      fontSize: 16,
                    }}
                  >
                    <span
                      style={{
                        marginRight: 10,
                        fontSize: isMobile ? 20 : 24,
                        flexShrink: 0,
                      }}
                    >
                      📊
                    </span>
                    <span>Real-time odds tracking across sportsbooks</span>
                  </div>
                  <div
                    className="font_family_base tour-small"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 15,
                      fontSize: 16,
                    }}
                  >
                    <span
                      style={{
                        marginRight: 10,
                        fontSize: isMobile ? 20 : 24,
                        flexShrink: 0,
                      }}
                    >
                      🔔
                    </span>
                    <span>Custom alert rules for your betting strategy</span>
                  </div>
                  <div
                    className="font_family_base tour-small"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 15,
                      fontSize: 16,
                    }}
                  >
                    <span
                      style={{
                        marginRight: 10,
                        fontSize: isMobile ? 20 : 24,
                        flexShrink: 0,
                      }}
                    >
                      📈
                    </span>
                    <span>Live chart view to track real-time odds data</span>
                  </div>
                  <div
                    className="font_family_base tour-small"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 15,
                      fontSize: 16,
                    }}
                  >
                    <span
                      style={{
                        marginRight: 10,
                        fontSize: isMobile ? 20 : 24,
                        flexShrink: 0,
                      }}
                    >
                      ⚡
                    </span>
                    <span>Instant notifications when opportunities match</span>
                  </div>
                  <div
                    className="font_family_base tour-small"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: 16,
                    }}
                  >
                    <span
                      style={{
                        marginRight: 10,
                        fontSize: isMobile ? 20 : 24,
                        flexShrink: 0,
                      }}
                    >
                      💰
                    </span>
                    <span>Real-time arbitrage and +EV betting opportunities</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Page 2: Live Odds Tracking */}
        {pageNumber === 2 && (
          <>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <div
                className="tour-emoji"
                style={{ fontSize: 60, marginBottom: 20 }}
              >
                📊
              </div>
              <h1
                className="font_family_base tour-h2 text-green"
                style={{ fontSize: 38, marginBottom: 20 }}
              >
                Track Live Odds
              </h1>
            </div>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <p
                className="font_family_base tour-body"
                style={{
                  fontSize: 18,
                  color: "#AAA",
                  lineHeight: 1.6,
                  marginBottom: 20,
                }}
              >
                Monitor real-time betting odds from major sportsbooks all in one
                place
              </p>
            </div>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <div
                className="tour-card background_3 border_radius"
                style={{
                  padding: 30,
                  marginTop: 40,
                  border: "2px solid #007bff",
                }}
                // className="tour-card"
                //                 style={{
                //                   backgroundColor: "#1a1a1a",
                //                   borderRadius: 12,
                //                   padding: 40,
                //                   marginBottom: 30,
                //                 }}
              >
                <div style={{ marginBottom: 30 }}>
                  <h3
                    className="font_family_base tour-h3"
                    style={{ fontSize: 22, marginBottom: 15, color: "#4CAF50" }}
                  >
                    Filter by Sport
                  </h3>
                  <p
                    className="font_family_base tour-small"
                    style={{ fontSize: 16, color: "#AAA", lineHeight: 1.6 }}
                  >
                    Browse NFL, NBA, MLB, NHL, and more. Focus on the sports you
                    love.
                  </p>
                </div>
                <div style={{ marginBottom: 30 }}>
                  <h3
                    className="font_family_base tour-h3"
                    style={{ fontSize: 22, marginBottom: 15, color: "#4CAF50" }}
                  >
                    Compare Sportsbooks
                  </h3>
                  <p
                    className="font_family_base tour-small"
                    style={{ fontSize: 16, color: "#AAA", lineHeight: 1.6 }}
                  >
                    See odds from DraftKings, FanDuel, BetMGM, and more
                    side-by-side.
                  </p>
                </div>
                <div>
                  <h3
                    className="font_family_base tour-h3"
                    style={{ fontSize: 22, marginBottom: 15, color: "#4CAF50" }}
                  >
                    All Bet Types
                  </h3>
                  <p
                    className="font_family_base tour-small"
                    style={{ fontSize: 16, color: "#AAA", lineHeight: 1.6 }}
                  >
                    Track Spreads, Over/Unders, and Moneylines with detailed
                    charts.
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Page 3: Custom Alerts */}
        {pageNumber === 3 && (
          <>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <div
                className="tour-emoji"
                style={{ fontSize: 60, marginBottom: 20 }}
              >
                🔔
              </div>
              <h1
                className="font_family_base tour-h2 text-green"
                style={{ fontSize: 38, marginBottom: 20 }}
              >
                Set Custom Alerts
              </h1>
            </div>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <p
                className="font_family_base tour-body"
                style={{
                  fontSize: 18,
                  color: "#AAA",
                  lineHeight: 1.6,
                  marginBottom: 20,
                }}
              >
                Never miss a betting opportunity with personalized alert rules
              </p>
            </div>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <div
                className="tour-card"
                style={{
                  // backgroundColor: "#1a1a1a",
                  borderRadius: 12,
                  padding: 40,
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    maxWidth: 600,
                    margin: "0 auto",
                    marginBottom: 30,
                  }}
                >
                  <h3
                    className="font_family_base tour-h3"
                    style={{ fontSize: 20, marginBottom: 20 }}
                  >
                    Create rules like:
                  </h3>
                  <div
                    className="tour-card background_3 border_radius"
                    style={{
                      padding: 30,
                      marginTop: 40,
                      border: "2px solid #007bff",
                      // marginBottom: 15,
                    }}
                    // style={{
                    //       backgroundColor: "#0a0a0a",
                    //       padding: isMobile ? 15 : 20,
                    //       borderRadius: 8,
                    //       marginBottom: 15,
                    //       border: "1px solid #333",
                    //     }}
                  >
                    <p
                      className="font_family_base tour-small"
                      style={{
                        fontSize: 16,
                        color: "#4CAF50",
                        marginBottom: 5,
                      }}
                    >
                      Example 1:
                    </p>
                    <p
                      className="font_family_base tour-small"
                      style={{ fontSize: 15 }}
                    >
                      "Alert me when any NBA game has a spread greater than 12
                      points on DraftKings or FanDuel"
                    </p>
                  </div>
                  <div
                    className="tour-card background_3 border_radius"
                    style={{
                      padding: 30,
                      marginTop: 40,
                      border: "2px solid #007bff",
                      // marginBottom: 15,
                    }}
                    //                     style={{
                    //   backgroundColor: "#0a0a0a",
                    //   padding: isMobile ? 15 : 20,
                    //   borderRadius: 8,
                    //   marginBottom: 15,
                    //   border: "1px solid #333",
                    // }}
                  >
                    <p
                      className="font_family_base tour-small"
                      style={{
                        fontSize: 16,
                        color: "#4CAF50",
                        marginBottom: 5,
                      }}
                    >
                      Example 2:
                    </p>
                    <p
                      className="font_family_base tour-small"
                      style={{ fontSize: 15 }}
                    >
                      "Notify me when any AFC team in the NFL has an over/under
                      drop below 42.5 on any sportbook"
                    </p>
                  </div>
                  <div
                    className="tour-card background_3 border_radius"
                    style={{
                      padding: 30,
                      marginTop: 40,
                      border: "2px solid #007bff",
                      // marginBottom: 15,
                    }}
                    // style={{
                    //   backgroundColor: "#0a0a0a",
                    //   padding: isMobile ? 15 : 20,
                    //   borderRadius: 8,
                    //   border: "1px solid #333",
                    // }}
                  >
                    <p
                      className="font_family_base tour-small"
                      style={{
                        fontSize: 16,
                        color: "#4CAF50",
                        marginBottom: 5,
                      }}
                    >
                      Example 3:
                    </p>
                    <p
                      className="font_family_base tour-small"
                      style={{ fontSize: 15 }}
                    >
                      "Alert when any MLB team's moneyline reaches +250 or
                      higher on BetMGM"
                    </p>
                  </div>
                </div>
                <div
                // style={{
                //   backgroundColor: "#0d2818",
                //   padding: isMobile ? 15 : 20,
                //   borderRadius: 8,
                //   border: "1px solid #4CAF50",
                // }}
                >
                  <p
                    className="font_family_base tour-small"
                    style={{ fontSize: 15 }}
                  >
                    💡 Set rules and get notified when conditions are met!
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Page 4: Historical Data */}
        {pageNumber === 4 && (
          <>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <div
                className="tour-emoji"
                style={{ fontSize: 60, marginBottom: 20 }}
              >
                📈
              </div>
              <h1
                className="font_family_base tour-h2 text-green"
                style={{ fontSize: 38, marginBottom: 20 }}
              >
                Analyze Live Trends
              </h1>
            </div>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <p
                className="font_family_base tour-body"
                style={{
                  fontSize: 18,
                  color: "#AAA",
                  lineHeight: 1.6,
                  marginBottom: 20,
                }}
              >
                Make informed decisions with detailed odds data and clear
                visuals charts
              </p>
            </div>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <div
                className="tour-card background_3 border_radius"
                style={{
                  padding: 30,
                  marginTop: 40,
                  border: "2px solid #007bff",
                }}
                //                     className="tour-card"
                // style={{
                //   backgroundColor: "#1a1a1a",
                //   borderRadius: 12,
                //   padding: 40,
                // }}
              >
                <div style={{ marginBottom: 30 }}>
                  <h3
                    className="font_family_base tour-h3"
                    style={{ fontSize: 22, marginBottom: 15, color: "#4CAF50" }}
                  >
                    📊 Interactive Charts
                  </h3>
                  <p
                    className="font_family_base tour-small"
                    style={{ fontSize: 16, color: "#AAA", lineHeight: 1.6 }}
                  >
                    Visualize how odds change over time with beautiful,
                    easy-to-read charts for each game.
                  </p>
                </div>
                <div style={{ marginBottom: 30 }}>
                  <h3
                    className="font_family_base tour-h3"
                    style={{ fontSize: 22, marginBottom: 15, color: "#4CAF50" }}
                  >
                    🔍 Compare Across Books
                  </h3>
                  <p
                    className="font_family_base tour-small"
                    style={{ fontSize: 16, color: "#AAA", lineHeight: 1.6 }}
                  >
                    See how different sportsbooks price the same game and spot
                    the best value.
                  </p>
                </div>
                <div>
                  <h3
                    className="font_family_base tour-h3"
                    style={{ fontSize: 22, marginBottom: 15, color: "#4CAF50" }}
                  >
                    ⏱️ Movement Patterns
                  </h3>
                  <p
                    className="font_family_base tour-small"
                    style={{ fontSize: 16, color: "#AAA", lineHeight: 1.6 }}
                  >
                    Identify trends and line movements to time your bets
                    perfectly.
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Page 5: Choose Your Plan */}
        {pageNumber === 5 && (
          <>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <div
                className="tour-emoji"
                style={{ fontSize: 60, marginBottom: 20 }}
              >
                🚀
              </div>
              <h1
                className="font_family_base tour-h2"
                style={{ fontSize: 38, marginBottom: 20 }}
              >
                Ready to Get Started?
              </h1>
            </div>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <p
                className="font_family_base tour-body"
                style={{
                  fontSize: 18,
                  color: "#AAA",
                  lineHeight: 1.6,
                  marginBottom: 20,
                }}
              >
                Choose a plan that works for you and start tracking odds today
              </p>
            </div>
            <div
              className="center_me"
              style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: "0 20px",
                textAlign: "center",
              }}
            >
              <div
                className="tour-card"
                style={{
                  // backgroundColor: "#1a1a1a",
                  borderRadius: 12,
                  padding: 40,
                  marginBottom: 30,
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: isMobile
                      ? "1fr"
                      : "repeat(auto-fit, minmax(220px, 1fr))",
                    gap: isMobile ? 15 : 20,
                    marginBottom: 30,
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#000000",
                      padding: isMobile ? 20 : 25,
                      borderRadius: 8,
                      border: "2px solid #007bff",
                    }}
                  >
                    <div
                      style={{ fontSize: isMobile ? 28 : 36, marginBottom: 10 }}
                    >
                      📱
                    </div>
                    <h3
                      className="font_family_base tour-h3"
                      style={{
                        fontSize: 18,
                        marginBottom: 10,
                        color: "#4CAF50",
                      }}
                    >
                      Basic
                    </h3>
                    <p
                      className="font_family_base tour-small"
                      style={{ fontSize: 14, color: "#AAA" }}
                    >
                      Live odds, game charts, and up to 5 alert rules
                    </p>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#000000",
                      padding: isMobile ? 20 : 25,
                      borderRadius: 8,
                      border: "2px solid #007bff",
                    }}
                  >
                    <div
                      className="tour-small"
                      style={{
                        backgroundColor: "#4CAF50",
                        color: "#000",
                        padding: "4px 12px",
                        borderRadius: 12,
                        fontSize: 11,
                        fontWeight: "bold",
                        display: "inline-block",
                        marginBottom: 10,
                      }}
                    >
                      POPULAR
                    </div>
                    <div
                      style={{ fontSize: isMobile ? 28 : 36, marginBottom: 10 }}
                    >
                      ⭐
                    </div>
                    <h3
                      className="font_family_base tour-h3"
                      style={{
                        fontSize: 18,
                        marginBottom: 10,
                        color: "#4CAF50",
                      }}
                    >
                      Pro
                    </h3>
                    <p
                      className="font_family_base tour-small"
                      style={{ fontSize: 14, color: "#AAA" }}
                    >
                      Unlimited rules, prop betting charts, and prop alert rules
                    </p>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#000000",
                      padding: isMobile ? 20 : 25,
                      borderRadius: 8,
                      border: "2px solid #007bff",
                    }}
                  >
                    <div
                      style={{ fontSize: isMobile ? 28 : 36, marginBottom: 10 }}
                    >
                      💎
                    </div>
                    <h3
                      className="font_family_base tour-h3"
                      style={{
                        fontSize: 18,
                        marginBottom: 10,
                        color: "#4CAF50",
                      }}
                    >
                      Premium
                    </h3>
                    <p
                      className="font_family_base tour-small"
                      style={{ fontSize: 14, color: "#AAA" }}
                    >
                      Everything in Pro, plus real-time Arb &amp; +EV opportunities and arb/EV alert rules
                    </p>
                  </div>
                </div>
                <div
                  style={
                    {
                      // backgroundColor: "#0d2818",
                      // padding: isMobile ? 15 : 20,
                      // borderRadius: 8,
                      // border: "1px solid #4CAF50",
                    }
                  }
                >
                  <p
                    className="font_family_base tour-small"
                    style={{ fontSize: 15, color: "#4CAF50", marginBottom: 5 }}
                  >
                    ✨ Start with a free trial
                  </p>
                  <p
                    className="font_family_base tour-small"
                    style={{ fontSize: 14, color: "#AAA" }}
                  >
                    Try all features risk-free before committing
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Navigation Buttons */}
        <div
          className="center_me"
          style={{
            marginTop: isMobile ? 40 : 50,
            display: "flex",
            gap: isMobile ? 10 : 15,
            justifyContent: "center",
            flexWrap: "wrap",
            padding: isMobile ? "0 15px" : "0",
          }}
        >
          {pageNumber !== 1 && (
            <button
              onClick={handlePrevious}
              className="my-form-button-wide button-base button-3d font_family_base"
              style={{
                marginTop: "5px",
                marginBottom: "5px",
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
              }}
            >
              ← Previous
            </button>
          )}
          <button
            onClick={handleNext}
            className="my-form-button-wide button-base button-3d font_family_base"
            style={{
              marginTop: "5px",
              marginBottom: "5px",
              backgroundImage: `url(${buttonBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              fontWeight: 700,
            }}
          >
            {pageNumber === 5
              ? "Pick Your Plan"
              : // ? isMobile
                //   ? "Choose Plan →"
                //   : "Choose Your Plan →"
                "Next →"}
          </button>
          {pageNumber < 5 && (
            <button
              onClick={handleSkip}
              className="my-form-button-wide button-base button-3d font_family_base"
              style={{
                marginTop: "5px",
                marginBottom: "5px",
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
              }}
            >
              Skip Tour
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
